import { useSideMenuContext } from "contexts/SideMenuContext";
import { Heading, List } from "@chakra-ui/react";
import { SideMenuItem } from "components/SideMenu";
import type { SideMenuProps } from "./types";

const sideMenuListStyles = {
  content: `""`,
  position: "absolute",
  borderLeft: "1px",
  borderColor: "greyscale.400",
  top: "8px",
  left: "-1px",
  height: "calc(100% - 17px)",
};

export const SideMenu = ({ pageHeading }: SideMenuProps) => {
  const { headings, activeHeading } = useSideMenuContext();

  return (
    pageHeading && (
      <>
        <Heading variant="h5" as="h5" mb={4} lineHeight="base">
          {pageHeading}
        </Heading>
        <List spacing={3} px={3} position="relative" ml="4px" _before={sideMenuListStyles}>
          {headings &&
            headings.map((heading) => (
              <SideMenuItem key={heading.current.id} heading={heading} isActive={heading === activeHeading} />
            ))}
        </List>
      </>
    )
  );
};
